import * as React from 'react';
import { ColumnHeader } from './Grid';
import { withTheme } from 'styled-components';
import { observer } from 'mobx-react';
import { Component } from 'react';

@observer
class ColumnHeaderExpander extends Component<any, any> {
    render() {
        const { theme } = this.props;
        return (
            <ColumnHeader paddingX="0" width="40px" {...theme.ColumnHeader} />
        );
    }
}

export default withTheme(ColumnHeaderExpander) as any;



// WEBPACK FOOTER //
// ./src/Components/ColumnHeaderExpander.tsx